import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import sv from './locales/sv.json'

// Get saved language from localStorage or default to Swedish
const savedLocale = localStorage.getItem('language') || 'sv'

const i18n = createI18n({
  legacy: false, // Use Composition API mode
  locale: savedLocale, // Set locale from localStorage
  fallbackLocale: 'en', // Fallback to English if translation missing
  messages: {
    en,
    sv
  },
  // Global properties to make it available in templates
  globalInjection: true
})

export default i18n
